export const resetScrollPosition = () => {
  window.scrollTo({ top: 0, left: 0, behavior: "auto" });
  document.documentElement.scrollTop = 0;
  document.body.scrollTop = 0;
};

const SCROLL_LOCK_INTERVAL_MS = 50;
const SCROLL_LOCK_DURATION_MS = 900;

export const lockScrollToTop = () => {
  resetScrollPosition();
  const interval = window.setInterval(resetScrollPosition, SCROLL_LOCK_INTERVAL_MS);
  const timeout = window.setTimeout(() => {
    window.clearInterval(interval);
    resetScrollPosition();
  }, SCROLL_LOCK_DURATION_MS);
  return () => {
    window.clearInterval(interval);
    window.clearTimeout(timeout);
  };
};
